"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_redux_1 = require("react-redux");
const qs_1 = __importDefault(require("qs"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const lodash_1 = require("lodash");
const selectors_1 = __importDefault(require("../../../slice/selectors"));
const sliceReview_1 = require("../../../slice/sliceReview");
const constants_1 = require("../../../slice/sliceReview/constants");
const store_1 = require("../../../store");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const PER_PAGE = 15;
const initialAssets = {
    items: [],
    total: 10,
    perPage: 10,
};
const ExistFile = () => {
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [total, setTotal] = (0, react_1.useState)(PER_PAGE);
    const [perPage, setPerPage] = (0, react_1.useState)(PER_PAGE);
    const [assets, setAssets] = (0, react_1.useState)(initialAssets);
    const [hasAssets, setHasAssets] = (0, react_1.useState)(true);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [searchingFile, setSearchingFile] = (0, react_1.useState)('');
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const { project, round, existingFiles } = (0, react_redux_1.useSelector)(selectors_1.default);
    const handleSelectionChange = (assetId) => {
        dispatch((0, sliceReview_1.updateExistingFiles)((0, lodash_1.xor)(existingFiles, [assetId])));
    };
    const jobId = (project === null || project === void 0 ? void 0 : project.value) || (round === null || round === void 0 ? void 0 : round.job_id);
    const fetchProjectAssets = (search) => {
        setLoading(true);
        const JQ_ASSETS_PROJECT = '{meta: .meta, data: [ .included as $included |.data[] as $data | $data | .relationships["uploaded-by"].data as $uploadedBy | .relationships."uploaded-by".data as $uploadedBy | .relationships["requirement"].data as $requirement | { assetId:  .attributes.asset_id,title:.attributes.title, keyDocument: .attributes.key_document,  version: .attributes.version,  status: .attributes.status, size: .attributes.size, totalDownload: .attributes.total_downloads, assetFrom: .attributes.asset_from, imagewidth:.attributes.imagewidth, imageheight: .attributes.imageheight, time: .attributes.time, mineAssetName: .attributes.mine_asset_name, assetPermission: .attributes.assetPermission, projectTypeId: .attributes.projectTypeId, uploadedBy: (if $uploadedBy  then $included[] | select(.type == $uploadedBy.type and .id == $uploadedBy .id) | {value: .attributes.userid, label: .attributes.name, raw: .attributes} else null end), uploadedAt: .attributes.time, job: (if $requirement then $included[] | select(.type == $requirement.type and .id == $requirement.id) | .relationships["job"].data as $job | (if $job then $included[] | select(.type == $job.type and .id == $job.id) | {value: .attributes.jobId, label: .attributes.jobTitle, raw: .attributes} else null end) else null end), client: (if $requirement then $included[] | select(.type == $requirement.type and .id == $requirement.id) | .relationships["job"].data as $job | (if $job then $included[] | select(.type == $job.type and .id == $job.id) | .relationships["client"].data as $client | (if $client then $included[] | select(.type == $client.type and .id == $client.id ) | {value: .attributes.clientid, label: .attributes.company, raw: .attributes} else null end) else null end) else null end)}  ]  }';
        const INCLUDE = 'uploaded-by,requirement.job,requirement.job.client';
        const filterParams = {
            jobid: jobId,
            // except assets is reviewing
            isNotReview: 1,
            includeRoundId: round === null || round === void 0 ? void 0 : round.id,
            isNotFinanceDocument: 1,
            assetName: search,
        };
        const params = {
            filter: filterParams,
            include: INCLUDE,
            jq: JQ_ASSETS_PROJECT,
            sort: '-assetid',
            page: {
                per_page: PER_PAGE,
                number: currentPage,
            },
        };
        const queryParamsString = qs_1.default.stringify(params, { encode: false });
        pulse_components_1.v2Endpoint
            .get(`/v2/api/assets?${queryParamsString}`)
            .then((res) => {
            var _a;
            const { data } = res === null || res === void 0 ? void 0 : res.data;
            const { page } = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.meta;
            if (data.length === 0) {
                // Check searching for avoiding render empty asset modal
                if (search !== '') {
                    setAssets(initialAssets);
                }
                else {
                    setHasAssets(false);
                }
            }
            else {
                setAssets({
                    items: data,
                    total: page === null || page === void 0 ? void 0 : page.total,
                    perPage: page === null || page === void 0 ? void 0 : page.per_page,
                });
                setTotal(page === null || page === void 0 ? void 0 : page.total);
                setPerPage(page === null || page === void 0 ? void 0 : page.per_page);
            }
            setLoading(false);
        })
            .catch((error) => {
            utilities_1.default.notification.danger(error);
            setLoading(false);
        });
    };
    const deboundSearch = (0, react_1.useCallback)((0, debounce_1.default)((search) => fetchProjectAssets(search), 300), []);
    (0, react_1.useEffect)(() => {
        fetchProjectAssets(searchingFile || '');
    }, [currentPage]);
    (0, react_1.useEffect)(() => {
        if (assets.items.length && existingFiles.length) {
            dispatch((0, sliceReview_1.enableNextBtn)());
            return;
        }
        dispatch((0, sliceReview_1.disableNextBtn)());
    }, [assets, existingFiles]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const handlePerPageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const debouncePageChange = (0, debounce_1.default)(handlePageChange, 200);
    const handleSearchingFile = (e) => {
        var _a, _b;
        setSearchingFile((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        setCurrentPage(1);
        deboundSearch((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value);
    };
    const handleClearSearchInput = () => {
        setSearchingFile('');
        fetchProjectAssets('');
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['existing-file'], "data-testid": "exist-file" }, hasAssets ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_modules_less_1.default['existing-file__search'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default.search__label },
                "Select an existing file to review from the project :",
                react_1.default.createElement("span", { className: styles_modules_less_1.default.search__job }, project === null || project === void 0 ? void 0 : project.label)),
            react_1.default.createElement(pulse_components_1.PulseInput, { InputBaseProps: {
                    onChange: handleSearchingFile,
                    classes: {
                        root: styles_modules_less_1.default['search-input__root'],
                        input: styles_modules_less_1.default['search-input__detail'],
                    },
                    placeholder: 'Search for a file...',
                    startAdornment: (react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-search', styles_modules_less_1.default['search-input__icon']) })),
                    endAdornment: searchingFile && (react_1.default.createElement(pulse_components_1.PulseIconButton, { classes: {
                            pulseIcon: {
                                icon: (0, clsx_1.default)('fal fa-times', styles_modules_less_1.default['search-input__end-icon']),
                            },
                        }, iconName: "", size: pulse_components_1.IconSizes.md, handleClick: handleClearSearchInput })),
                    value: searchingFile,
                } })),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['existing-file__assets'] },
            react_1.default.createElement(pulse_components_1.PulseScrollbar, null,
                react_1.default.createElement("div", { className: styles_modules_less_1.default.assets__warning },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['assets-warning__icon'] },
                        react_1.default.createElement("i", { className: 'fal fa-info-circle' })),
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['warning-label__root'] },
                        react_1.default.createElement("span", { className: (0, clsx_1.default)(styles_modules_less_1.default['warning-label__text'], styles_modules_less_1.default['warning-label__text--bold']) }, "Please select from the available Assets in this Project to add to the next Round of Review."),
                        react_1.default.createElement("span", { className: (0, clsx_1.default)(styles_modules_less_1.default['warning-label__text']) }, "Please select from the available Assets in this Project to create a Review."))),
                react_1.default.createElement("div", { className: styles_modules_less_1.default.assets__list, key: total },
                    react_1.default.createElement(pulse_components_1.PulsePagination, { currentPage: currentPage, total: total, perPage: perPage, onPageChange: debouncePageChange, onPerPageChange: handlePerPageChange, sticky: true }, assets.items.length === 0 && searchingFile && !loading ? (react_1.default.createElement("div", { className: styles_modules_less_1.default['searching-asset'] },
                        react_1.default.createElement("div", { className: styles_modules_less_1.default['searching-asset__icon'] },
                            react_1.default.createElement("i", { className: "fal fa-exclamation-circle" })),
                        react_1.default.createElement("h3", null, "No Asset Found"))) : (react_1.default.createElement(pulse_components_1.PulseGalleryItems, { assets: assets.items, classes: {
                            root: styles_modules_less_1.default['list-asset__root'],
                        }, onSelectionChange: handleSelectionChange, PulseGalleryItemProps: {
                            classes: {
                                root: styles_modules_less_1.default.asset__root,
                            },
                        }, showLoading: !assets.items.length ? PER_PAGE : 0, selectedAssets: existingFiles })))))))) : (react_1.default.createElement("div", { className: styles_modules_less_1.default['warning-file__assets'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['warning-assets__icon'] },
            react_1.default.createElement("i", { className: "fal fa-exclamation-circle" })),
        react_1.default.createElement("h3", { className: styles_modules_less_1.default['warning-assets__title'] }, "There are no assets uploaded to this project yet."),
        react_1.default.createElement("p", { className: styles_modules_less_1.default['warning-assets__content'] },
            "You can upload the first asset to this project and assign it to this review via the ",
            react_1.default.createElement("u", null, "media manager uploader"),
            "."),
        react_1.default.createElement(pulse_components_1.PulseButton, { onClick: () => dispatch((0, sliceReview_1.updatePhase)(constants_1.PHASE.chooseUpload)), classes: [styles_modules_less_1.default['warning-btn']], label: 'Upload a file', icon: true, iconPosition: "left", color: pulse_components_1.Colors.success, iconClasses: {
                icon: (0, clsx_1.default)('fal fa-cloud-upload', styles_modules_less_1.default['warning-btn__icon']),
            } })))));
};
exports.default = ExistFile;
